module.exports = __webpack_public_path__ + "img/tab-image-yoga-shopAvatar.24125e08.png";